import axios from "axios";



// Ürünleri Getir
export const fetchProducts = async (filters) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/product`, {
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error; // Hata yönetimi için hatayı tekrar fırlatıyoruz
  }
};

export const fetchProductById = async (id) => {
  try {
    // Ürünü getir
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/product/${id}`);
    const product = response.data;

    if (!product || !product.id) {
      throw new Error("Ürün bulunamadı.");
    }

    // Ürün puanını getir
    const ratingResponse = await axios.get(`${process.env.REACT_APP_API_URL}/comment/rating/${product.id}`);

    return {
      ...product,
      averageRating: ratingResponse.data.averageRating || 0,
      totalRatings: ratingResponse.data.totalRatings || 0,
    };
  } catch (error) {
    console.error(`Ürün veya puan getirme hatası (ID: ${id}):`, error);
    throw error; // Hata yönetimi için hatayı tekrar fırlatıyoruz
  }
};

export const fetchReviewsByProductId = async (productId, token) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/comment/${productId.productId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data || []; // Eğer null gelirse boş array döndür
  } catch (error) {
    console.error("Yorumlar yüklenirken hata:", error);
    return []; // Hata durumunda boş array döndür
  }
};
export const addReview = async (data, token) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/comment`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Yorum gönderme hatası:", error);
    console.error("Hata detayı:", error.response?.data);
    throw error.response?.data?.message || "Yorum eklenirken bir hata oluştu";
  }
};

export const getProductById = async (id) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/product/by/${id}`);
    return response.data;
  } catch (error) {
    console.error('Ürün detayı alınırken bir hata oluştu:', error.message);
    throw error;
  }
};
export const getFeaturedProducts = async () => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/product/top-viewed`);
    const raw = Array.isArray(res.data) ? res.data : [];

    // Sayı dönüştürme yardımcıları
    const toNumberOrNull = (v) => {
      if (v === null || v === undefined || v === '') return null;
      // Olası "123,45" gibi değerler için virgülü noktaya çevir
      const n = Number(String(v).replace(',', '.'));
      return Number.isFinite(n) ? n : null;
    };

    // Ürünleri normalize et
    return raw.map((p) => {
      const original = toNumberOrNull(p.original_price);
      const discounted = toNumberOrNull(p.discounted_price);

      // Görünecek fiyat
      const price = Number.isFinite(discounted) ? discounted
                  : Number.isFinite(original)   ? original
                  : 0; // son çare: 0 (NaN patlamasını engeller)

      return {
        ...p,
        original_price: original,
        discounted_price: discounted,
        price, // istersen ProductCard içinde bu alanı doğrudan kullanabilirsin
        views: Number(p.views) || 0,
        in_stock: !!p.in_stock,
        show_colors: !!p.show_colors,
        show_sizes: !!p.show_sizes,
        has_discount: !!p.has_discount && Number.isFinite(discounted) && Number.isFinite(original) && discounted < original,
      };
    });
  } catch (error) {
    console.error('Öne çıkan ürünler alınırken hata oluştu:', error);
    throw error;
  }
};